import { Component, OnInit, OnDestroy }     from '@angular/core';
import { Router }                           from '@angular/router';
import { BatchResponse }                    from '../../../models/program/batch-response';
import { ProgramWithSessions }              from '../../../models/program/program-with-sessions';
import { SessionDetails }                   from '../../../models/program/session-details';
import { RouteOptions }                     from '../../../models/route-options';
import { ISubscription }                    from 'rxjs/Subscription';
import { ProgramService }                   from '../../../shared/services/program.service';
import { ActivatedRoute, Params }           from '@angular/router';
import { PermissionsService }               from '../../../shared/services/permissions.service';
import { CsvService }                       from '../../../dashboard/program-list/csv.service';

@Component({
  selector: 'app-session',
  templateUrl: './program-with-sessions.component.html',
  styleUrls: ['./program-with-sessions.component.less'],
  providers: []
})

export class ProgramWithSessionsComponent implements OnInit, OnDestroy {
  program: ProgramWithSessions;
  programSub: ISubscription;
  programId: number;
  addSession: boolean;
  moveTeam?: number;
  addMenu: boolean;
  deleteTeam?: number;
  minimalStateObj: {categoryType: string; mapping: string, categoryId: number};
  errors: string[]; // TO DO - display errors
  linksFilteredForPermissions: RouteOptions[];
  links: RouteOptions[]
  batchResponse: BatchResponse;
  batchSession: SessionDetails;
  batchProgram: ProgramWithSessions;
  simplifiedInterface = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private programService: ProgramService,
    private permissionsService: PermissionsService,
    private csvService: CsvService,
  ) { }

  ngOnInit(): void {
    this.setProgramIdAndStateObj();
    this.links = [
      {
        ref: [],
        title: 'Sessions',
        showForSimplified: true
      },
      {
        ref: ['/', 'dashboard', 'programs', this.programId, 'appearance'],
        title: 'Appearance',
        permission: 'nomadicAdministration'
      },
      {
        ref: ['/', 'dashboard', 'programs', this.programId, 'admins'],
        title: 'Admins'
      },
      {
        ref: ['/', 'dashboard', 'programs', this.programId, 'content'],
        title: 'Content',
        permission: 'nomadicAdministration'
      },
      {
        ref: ['/', 'dashboard', 'programs', this.programId, 'other-settings'],
        title: 'Other Settings'
      },
      {
        ref: ['/', 'dashboard', 'programs', this.programId, 'changes'],
        title: 'Change Log',
        permission: 'nomadicAdministration'
      }
    ];
    this.permissionsService.retrievePermissions().subscribe(permissions => {
      this.linksFilteredForPermissions =
        this.links
          .filter(link => link.permission ? permissions[link.permission] : true)
          .filter(link => this.simplifiedInterface ? link.showForSimplified : true);
    });
    this.simplifiedInterface = this.permissionsService.simplifiedSessionManagement;
    this.subscribeToGetProgram();
  }

  setProgramIdAndStateObj(): void {
    this.route.params.forEach((params: Params) => {
      this.programId = +params['programId'];
      this.minimalStateObj = {
        categoryType: 'program',
        mapping: 'session',
        categoryId: this.programId
      };
    });
  }

  teamMenuItemSelected(itemName: string, teamId: number): void {
    if (itemName === 'openAsTeam') {
      window.open(`/library?groupselect=${teamId}`);;
    } else if (itemName === 'moveTeam') {
      this.moveTeam = teamId;
    } else if (itemName === 'deleteTeam') {
      this.deleteTeam = teamId;
    } else {
      this.toggleField[itemName];
    }
  }

  toggleField(field: string): void {
    this[field] = !this[field];
  }

  routeToLearners(teamId: number): void {
    this.router.navigate(['dashboard', 'programs', this.programId, 'teams', teamId, 'users']);
  }

  subscribeToGetProgram(): void {
    this.programSub = this.programService
      .getProgramWithSessions(this.programId, true)
      .subscribe(program => {
        this.program = program;
      });
  }

  gotBatch(session: SessionDetails, program: ProgramWithSessions, batch: BatchResponse) {
    this.batchResponse = batch;
    this.batchProgram = program;
    this.batchSession = session;
  }

  resetBatch() {
    this.batchResponse = null;
    this.batchProgram = null;
    this.batchSession = null;
    this.subscribeToGetProgram();
  }

  ngOnDestroy(): void {
    this.programSub.unsubscribe();
  }
}





// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program-with-sessions/program-with-sessions.component.ts